import { render, staticRenderFns } from "./LigetPlusDetailsBlock.vue?vue&type=template&id=b39ab104&scoped=true&"
import script from "./LigetPlusDetailsBlock.vue?vue&type=script&lang=js&"
export * from "./LigetPlusDetailsBlock.vue?vue&type=script&lang=js&"
import style0 from "./LigetPlusDetailsBlock.vue?vue&type=style&index=0&id=b39ab104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39ab104",
  null
  
)

export default component.exports